import licenseModule from '../../license.module';

export default licenseModule.component('licenseConsoleNewServerDetails', {
    template: require('./licenseConsoleNewServerDetails.component.html'),
    controller: licenseConsoleNewServerDetailsComponent,
    bindings: {
        name: '<',
        description: '<',
        callback: '&'
    }
});

function licenseConsoleNewServerDetailsComponent() {
    var vm = this;
    vm.minLength = 1;
    vm.maxLength = 100;

    vm.$onInit = function() {
        vm.name = '';
        vm.description = '';
        vm.eula = false;
    };
    vm.changes = function() {
        var value = {
            name: vm.name,
            description: vm.description,
            countryCode: vm.countryCode,
            eula: vm.eula
        };
        vm.callback({ value: value });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-console-new-server-details/licenseConsoleNewServerDetails.component.js